import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgSortAscending = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 12"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 6a.375.375 0 0 1-.375.375H2.25a.375.375 0 1 1 0-.75h3.375A.375.375 0 0 1 6 6M2.25 3.375h6.375a.375.375 0 0 0 0-.75H2.25a.375.375 0 1 0 0 .75m2.625 5.25H2.25a.375.375 0 1 0 0 .75h2.625a.375.375 0 1 0 0-.75m5.89-1.015a.375.375 0 0 0-.53 0L9 8.845V5.25a.375.375 0 1 0-.75 0v3.595L7.015 7.61a.375.375 0 1 0-.53.53l1.875 1.875a.375.375 0 0 0 .53 0l1.875-1.875a.375.375 0 0 0 0-.53"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSortAscending);
export default ForwardRef;
